import { env } from '@/env.mjs'

// Locales are defined in i18n/routing via defineRouting
export const APP_LOCALES = env.NEXT_PUBLIC_LOCALIZATION_ENABLED ? ['en', 'es-ES', 'de-DE'] : ['en']
export const APP_DEFAULT_LOCALE = 'en'

export const LOCALE_TRANSLATION = {
	en: 'English',
	'es-ES': 'Español',
	'fr-FR': 'Français',
	'de-DE': 'Deutsch',
}
